module.exports = __webpack_public_path__ + "fonts/montserrat-blackitalic-webfont.874bad1.woff";